import { forwardRef } from 'react';

/**
 * A centred placeholder for empty lists/views (spec §7.2).
 *
 * @param {object} props
 * @param {import('react').ReactNode} [props.icon] - decorative; always
 *   rendered `aria-hidden`.
 * @param {import('react').ReactNode} [props.title]
 * @param {import('react').ReactNode} [props.children] - body copy.
 * @param {import('react').ReactNode} [props.action] - e.g. a `<Button>` to
 *   resolve the empty state.
 * @param {string} [props.className]
 */
export const EmptyState = forwardRef(function EmptyState({ icon, title, children, action, className = '', ...rest }, ref) {
  return (
    <div ref={ref} className={`etch-empty ${className}`.trim()} {...rest}>
      {icon && (
        <span aria-hidden="true">{icon}</span>
      )}
      {title && <div className="etch-empty__title">{title}</div>}
      {children && <div className="etch-empty__body">{children}</div>}
      {action && <div>{action}</div>}
    </div>
  );
});

export default EmptyState;
